import { render, staticRenderFns } from "./ProjectSteps.vue?vue&type=template&id=1c6cf588&scoped=true&"
import script from "./ProjectSteps.vue?vue&type=script&lang=js&"
export * from "./ProjectSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSteps.vue?vue&type=style&index=0&id=1c6cf588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6cf588",
  null
  
)

export default component.exports